import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-panel" }
const _hoisted_2 = { class: "user-info" }
const _hoisted_3 = { class: "user-name" }

import DxContextMenu, { DxPosition } from "devextreme-vue/context-menu";
import DxList from "devextreme-vue/list";
import { ref, onMounted, computed } from "vue";
import { useCurrentUserStore } from "../../stores/CurrentUserStore";
import { CurrentUser } from "@/types/user/CurrentUser";


export default /*#__PURE__*/_defineComponent({
  __name: 'user-panel',
  props: {
  /**
   * Defines the mode of the menu.
   * Can be used to determine different menu layouts or behaviors.
   * @type {string}
   * @default ''
   */
  menuMode: {
    type: String,
    default: "",
  },

  /**
   * An array of menu items to be displayed in the menu.
   * @type {Array}
   * @default []
   */
  menuItems: {
    type: Array,
    default: () => [],
  },
},
  setup(__props) {



const currentUser = ref<CurrentUser>();
const currentUserStore = useCurrentUserStore();

onMounted(async () => {
  // Get Current User details from the Current User store
  currentUser.value = await currentUserStore.getCurrentUserDetails();
});

/*** Gets initials of the currently logged in user */
const userInitials = computed(() => {
  if (!currentUser.value?.name) {
    return "";
  }

  /* Find the first letter of the first 2 words in the user's name
   * Due to available space, we shouldn't show more than 2 initials */
  const initials = currentUser.value.name
    .match(/\b(\w)/g)
    ?.slice(0, 2)
    ?.join("");

  return initials ?? "";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(userInitials.value), 1)
    ]),
    (__props.menuMode === 'context')
      ? (_openBlock(), _createBlock(_unref(DxContextMenu), {
          key: 0,
          target: ".user-button",
          items: __props.menuItems,
          width: 100,
          "show-event": "dxclick",
          "css-class": "user-menu"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(DxPosition), {
              my: "top center",
              at: "bottom center"
            })
          ]),
          _: 1
        }, 8, ["items"]))
      : _createCommentVNode("", true),
    (__props.menuMode === 'list')
      ? (_openBlock(), _createBlock(_unref(DxList), {
          key: 1,
          class: "dx-toolbar-menu-action",
          items: __props.menuItems
        }, null, 8, ["items"]))
      : _createCommentVNode("", true)
  ]))
}
}

})